import { IAction, IIdentityContextState } from './identity-interfaces';
import { identityActionTypes } from './identity-action-types';

export const identityReducer = (state: IIdentityContextState, action?: IAction): IIdentityContextState => {
	switch (action.type) {
		case identityActionTypes.START_USERS_LIST_LOADING: {
			return {
				...state,
				isUserListLoading: true,
			};
		}
		case identityActionTypes.FETCH_USERS_LIST: {
			return {
				...state,
				isUserListLoading: false,
				usersList: action.payload,
			};
		}
		case identityActionTypes.SET_USER_DATA_LOADING: {
			return { ...state, isUserDataLoading: action.payload };
		}
		case identityActionTypes.FETCH_USER_DATA: {
			return {
				...state,
				isUserDataLoading: false,
				userData: action.payload,
			};
		}
		case identityActionTypes.START_CREATING_USER_LOADING: {
			return {
				...state,
				isNewUserLoading: true,
			};
		}
		case identityActionTypes.END_CREATING_USER_LOADING: {
			return {
				...state,
				isNewUserLoading: false,
			};
		}
		case identityActionTypes.SET_LOADING_SECURITY_INFORMATION: {
			return { ...state, isSecurityDataLoading: action.payload };
		}
		case identityActionTypes.FETCH_SECURITY_INFORMATION: {
			return {
				...state,
				securityData: action.payload,
				isSecurityDataLoading: false,
			};
		}
		case identityActionTypes.SET_TWO_FACTOR_ENABLE_LOADING: {
			return { ...state, isTwoFactorEnableLoading: action.payload };
		}
		case identityActionTypes.START_CODE_VERIFICATION_LOADING: {
			return {
				...state,
				isCodeVerificationLoading: true,
			};
		}
		case identityActionTypes.END_CODE_VERIFICATION_LOADING: {
			return {
				...state,
				isCodeVerificationLoading: false,
			};
		}
		case identityActionTypes.START_VERIFICATION_LOGIN_CODE_LOADING: {
			return {
				...state,
				isVerificationLoginCodeLoading: true,
			};
		}
		case identityActionTypes.END_VERIFICATION_LOGIN_CODE_LOADING: {
			return {
				...state,
				isVerificationLoginCodeLoading: false,
			};
		}
		case identityActionTypes.START_REMOVING_TWO_FACTOR_AUTH_LOADING: {
			return {
				...state,
				isRemovingTwoFactorAuthLoading: true,
			};
		}
		case identityActionTypes.END_REMOVING_TWO_FACTOR_AUTH_LOADING: {
			return {
				...state,
				isRemovingTwoFactorAuthLoading: false,
			};
		}
		case identityActionTypes.START_CHANGE_PASSWORD_LOADING: {
			return {
				...state,
				isChangePasswordLoading: true,
			};
		}
		case identityActionTypes.END_CHANGE_PASSWORD_LOADING: {
			return {
				...state,
				isChangePasswordLoading: false,
			};
		}
		case identityActionTypes.USER_NEXT_PAGE: {
			return {
				...state,
				hasUserNextPage: action.payload,
			};
		}
		case identityActionTypes.FETCH_ACCOUNT_MANAGER_LIST: {
			return {
				...state,
				accountManagerList: action.payload,
				isAccountManagerListLoading: false,
			};
		}
		case identityActionTypes.SET_ACCOUNT_MANAGER_LIST_LOADING: {
			return { ...state, isAccountManagerListLoading: action.payload };
		}
		case identityActionTypes.SET_RESEND_INVITATION_LOADING: {
			return { ...state, isResendInvitationLoading: action.payload };
		}
		case identityActionTypes.FETCH_FAIL: {
			return {
				...state,
				isUserListLoading: false,
				isNewUserLoading: false,
				isCodeVerificationLoading: false,
				isVerificationLoginCodeLoading: false,
				isRemovingTwoFactorAuthLoading: false,
				isChangePasswordLoading: false,
			};
		}
		default: {
			return state;
		}
	}
};
